import type {
	ShopDto,
	UpdateOneKlaviyoIntegrationDto,
} from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useUpdateKlaviyoIntegration(shop: ShopDto) {
	const invalidateShop = useInvalidateShop(shop.id);

	return useApiMutation(
		"patch",
		"/shops/{shopId}/integrations/klaviyo",
		{
			invalidate: invalidateShop,
			mapVariables: (requestBody: UpdateOneKlaviyoIntegrationDto) => ({
				params: { path: { shopId: shop.id } },
				body: requestBody,
			}),
		},
	);
}
